import Vue from 'vue'
import Router from 'vue-router'
import layout from "@/layout/index.vue";

Vue.use(Router)

const constantRoutes = [
    {
        path: '/login',
        component: () => import('@/login/index.vue'),
        hidden: true,
    },
    {
        path: '/',
        component: layout,
        children: [
            {
                path: '/homePages',
                component: () => import('@/views/homePages/index.vue'),
                hidden: true,
                meta: {title: '首页'}
            },
            {
                path: '/productCenter',
                component: () => import('@/views/productCenter/index.vue'),
                hidden: true,
                meta: {title: '产品中心'}
            },
            {
                path: '/productTypeDetail',
                component: () => import('@/views/productCenter/productType/productTypeDetail.vue'),
                hidden: true,
                meta: {title: '产品类型详情'}
            },
            {
                path: '/productType/productTypeDetail',
                component: () => import('@/views/productCenter/productType/productTypeDetail.vue'),
                hidden: true,
                meta: {title: '产品类型详情'}
            },
            {
                path: '/productType/productTypeMilling',
                component: () => import('@/views/productCenter/productType/productTypeMilling.vue'),
                hidden: true,
                meta: {title: '产品类型详情'}
            },
            {
                path: '/productTypeList',
                component: () => import('@/views/productCenter/productType/productTypeList.vue'),
                hidden: true,
                meta: {title: '产品类型列表'}
            },
            {
                path: '/productType/productTypeList',
                component: () => import('@/views/productCenter/productType/productTypeList.vue'),
                hidden: true,
                meta: {title: '产品类型列表'}
            },
            {
                path: '/productAttachment',
                component: () => import('@/views/productCenter/productType/productAttachment.vue'),
                hidden: true,
                meta: {title: '产品附件'}
            },
            {
                path: '/productType/productAttachment',
                component: () => import('@/views/productCenter/productType/productAttachment.vue'),
                hidden: true,
                meta: {title: '产品附件'}
            },
            {
                path: '/industryApplications',
                component: () => import('@/views/industryApplications/index.vue'),
                hidden: true,
                meta: {title: '行业应用'}
            },
            {
                path: '/newsEvents',
                component: () => import('@/views/newsEvents/index.vue'),
                hidden: true,
                meta: {title: '新闻与活动'}
            },
            {
                path: '/newsEventsDetails/:id',
                component: () => import('@/views/newsEvents/newsEventsDetails/index.vue'),
                hidden: true,
                meta: {title: '新闻详情'}
            },
            {
                path: '/industryDetail/:id',
                component: () => import('@/views/industryApplications/industryDetail/index.vue'),
                hidden: true,
                meta: {title: '行业应用详情'}
            },
            {
                path: '/walksLife/:id',
                component: () => import('@/views/walksLife/index.vue'),
                hidden: true,
                meta: {title: '各行各业详情'}
            },
            {
                path: '/serviceRepair',
                component: () => import('@/views/serviceRepair/index.vue'),
                hidden: true,
                meta: {title: '服务维修'}
            },
            {
                path: '/aboutUs',
                component: () => import('@/views/aboutUs/index.vue'),
                hidden: true,
                meta: {title: '关于我们'}
            },
            {
                path: '/contactUS',
                component: () => import('@/views/contactUS/index.vue'),
                hidden: true,
                meta: {title: '联系方式'}
            },
            {
                path: '/shoppingMall',
                component: () => import('@/views/shoppingMall/index.vue'),
                hidden: true,
                meta: {title: '商城'}
            },
            {
                path: '/waresDetails',
                component: () => import('@/views/shoppingMall/waresDetails/index.vue'),
                hidden: true,
                meta: {title: '详情'}
            },
            {
                path: '/productDetail',
                component: () => import('@/views/productCenter/productDetails/index.vue'),
                hidden: true,
                meta: {title: '详情'}
            },
            {
                path: '/productCompared',
                component: () => import('@/views/productCenter/productCompared/index.vue'),
                hidden: true,
                meta: {title: '对比'}
            },
            {
                path: '/userInfo',
                component: () => import('@/views/userInfo/index.vue'),
                hidden: true,
                meta: {title: '个人中心',requiresAuth: true}
            },
            {
                path: '/receivingAddress',
                component: () => import('@/views/userInfo/receivingAddress/index.vue'),
                hidden: true,
                meta: {title: '收货地址',requiresAuth: true}

            },
            {
                path: '/orderTable',
                component: () => import('@/views/shoppingMall/orderTable/index.vue'),
                hidden: true,
                meta: {title: '订单管理',requiresAuth: true}
            },
            {
                path: '/orderDetail',
                component: () => import('@/views/shoppingMall/orderTable/orderDetail/index.vue'),
                hidden: true,
                meta: {title: '订单详情',requiresAuth: true}
            },
            {
                path: '/payShopp',
                component: () => import('@/views/shoppingMall/waresDetails/payShopp.vue'),
                hidden: true,
                meta: {title: '商品购买',requiresAuth: true}
            },
            {
                path: '/wxBind',
                component: () => import('@/views/userInfo/wxBind.vue'),
                hidden: true,
                meta: {title: '绑定微信',requiresAuth: true}
            }
        ]
    },
]


// const router = createRouter({
//   history: createWebHashHistory(),
//   routes
// })
export default new Router({
    mode: 'history', // 去掉url中的#
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})
